import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import * as styles from './styles.ve.css';
import { Testimonial as TestimonialProps } from './constants';

const DEFAULT_LOGO_SRC =
  'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e5c8609938efcfe78ad238aef605514a-1752469469636/image%201881.png';

const TestimonialCard = ({ logoSrc, quote, author, authorTitle }: TestimonialProps) => (
  <Stack
    direction="column"
    gap="8"
    paddingY={{ default: '6', sm: '6', xl: '8' }}
    paddingX={{ default: '4', sm: '6', xl: '8' }}
    width={{ default: '282px', sm: '339px', lg: '330px', xl: '424px' }}
    height={{ default: '366px', sm: '374px', md: '388px', xl: '432px' }}
    backgroundColor="white"
    className={styles.testimonialCard}
  >
    <Stack direction="row">
      <Image
        src={logoSrc ?? DEFAULT_LOGO_SRC}
        height={{ default: '25px', xl: '40px' }}
        width="fit-content"
        objectFit="contain"
        alt="Logo"
      />
    </Stack>
    <Stack direction="column" justifyContent="spaceBetween" flexGrow={1}>
      <Text className={styles.testimonialText} color="bodySecondary">
        {`"${quote}"`}
      </Text>
      <Container width="100%">
        <Text fontWeight="semibold" className={styles.testimonialAuthorName}>
          {author}
        </Text>
        <Text className={styles.testimonialAuthorTitle}>{authorTitle}</Text>
      </Container>
    </Stack>
  </Stack>
);

export default TestimonialCard;
